<template>
  <div class="theloader-wrapper">
    <div class="theloader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        height="435"
        viewBox="0 0 537 435"
        width="537"
        data-v-3089ed99=""
      >
        <g fill="none" fill-rule="evenodd" data-v-3089ed99="">
          <path
            d="m177 151.4024 90.99786 27.5976.00214-34.4024-91-27.5976z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m359 151.4024-90.99786 27.5976-.00214-34.4024 91-27.5976z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m286.447838 163.354801c3.740156-1.143558 6.766069-5.091504 6.766069-8.829976s-3.025913-5.839626-6.766069-4.696068-6.768207 5.091504-6.768207 8.829976 3.028051 5.839626 6.768207 4.696068"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m268.191642 89.8661454-90.948448 27.5928736 90.94631 27.592873 90.948449-27.592873z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m187.601865 114.316693 80.589777 24.450761 80.58764-24.450761-80.58764-24.4507613z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m177.243621 107.064185 90.946311 27.592874.002138-34.39437-90.948449-27.595011z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m359.137525 107.064185-90.94631 27.592874-.002139-34.39437 90.948449-27.595011z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m268.191642 45.0758736-90.948448 27.5928731 90.94631 27.5928733 90.948449-27.5928733z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m187.601865 69.5159473 80.589777 24.4507611 80.58764-24.4507611-80.58764-24.4507612z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m177.243621 62.2728448 90.946311 27.5928731.002138-34.3943699-90.948449-27.5928732z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m359.137525 62.2728448-90.94631 27.5928731-.002139-34.3943699 90.948449-27.5928732z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m90.9897726.28453295-90.94844868 27.59287315 90.94631028 27.5928731 90.9484488-27.5928731z"
            fill="rgb(119, 217, 226)"
            mask="url(#a)"
            transform="translate(177.20187)"
            data-v-3089ed99=""
          ></path>
          <g fill="#77d9e2" data-v-3089ed99="">
            <path
              d="m310.871977 58.8316978c-1.208227-.5664351-2.008009-1.8553423-2.016562-3.5995351-.010693-2.8642381 2.1021-5.8439008 4.719568-6.6561474 2.617467-.8122466 4.747367.8507215 4.760198 3.7149596.008554 1.7441928-.778397 3.5247229-1.980208 4.83928l3.472849 10.7793678-3.470711 1.075158-5.386765 1.6715181-3.470711 1.0772955z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m310.871977 102.752652c-1.208227-.566435-2.008009-1.855342-2.016562-3.5995351-.010693-2.8642381 2.1021-5.8439007 4.719568-6.6561474 2.617467-.8122466 4.747367.852859 4.760198 3.7170971.008554 1.7420553-.778397 3.5225854-1.980208 4.8371424l3.472849 10.779368-3.470711 1.077295-5.386765 1.671519-3.470711 1.077295z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m310.871977 146.076391c-1.208227-.566435-2.008009-1.855342-2.016562-3.599535-.010693-2.864238 2.1021-5.843901 4.719568-6.656147 2.617467-.812247 4.747367.850721 4.760198 3.714959.008554 1.744193-.778397 3.524723-1.980208 4.83928l3.472849 10.779368-3.470711 1.075158-5.386765 1.671518-3.470711 1.077296z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m187.948508 53.1154052v5.0231042l39.443784 11.9678129v-5.0209667z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m187.948508 41.8809656v5.0231041l39.443784 11.9678129v-5.0231041z"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m249.727589 74.9308536c-3.740156-1.1435578-6.768207-5.0936414-6.768207-8.8299759 0-3.738472 3.028051-5.8396258 6.768207-4.6982056 3.740156 1.1435578 6.766069 5.0936414 6.766069 8.8321134s-3.025913 5.8396258-6.766069 4.6960681"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m281.312555 64.687996c1.700071-.5194103 3.077235-2.3170404 3.077235-4.0163458 0-1.701443-1.377164-2.6569015-3.077235-2.1353537-1.700071.5194104-3.077236 2.3149029-3.077236 4.0142084 0 1.7014429 1.377165 2.6569015 3.077236 2.1374911"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m344.132849 85.559742c1.30018-.3975733 2.354438-1.7719801 2.354438-3.0715747 0-1.2995947-1.054258-2.0306166-2.354438-1.6330433-1.30018.3975734-2.3523 1.7719802-2.3523 3.0715748s1.05212 2.0306166 2.3523 1.6330432"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m352.853678 83.0997035c1.30018-.3975734 2.352299-1.7719802 2.352299-3.0715748s-1.052119-2.0306166-2.352299-1.6330432c-1.30018.3975733-2.354438 1.7719801-2.354438 3.0715747 0 1.2995947 1.054258 2.0306166 2.354438 1.6330433"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m350.573231 133.952755c1.700071-.521548 3.077235-2.31704 3.077235-4.016346 0-1.701443-1.377164-2.656901-3.077235-2.135353-1.700071.51941-3.077236 2.314903-3.077236 4.014208 0 1.701443 1.377165 2.656902 3.077236 2.137491"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m350.573231 147.583536c1.700071-.51941 3.077235-2.314903 3.077235-4.016346s-1.377164-2.656901-3.077235-2.135353c-1.700071.51941-3.077236 2.314903-3.077236 4.016346 0 1.699305 1.377165 2.654764 3.077236 2.135353"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m187.948508 98.2166821v5.0231039l39.443784 11.967813v-5.020967z"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m187.948508 86.9822424v5.0231042l39.443784 11.9678124v-5.0231037z"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <g fill="#77d9e2" data-v-3089ed99="">
            <path
              d="m249.727589 120.03213c-3.740156-1.143557-6.768207-5.093641-6.768207-8.832113 0-3.736335 3.028051-5.837488 6.768207-4.696068 3.740156 1.143558 6.766069 5.093641 6.766069 8.832113s-3.025913 5.839626-6.766069 4.696068"
              data-v-3089ed99=""
            ></path>
            <path
              d="m187.948508 141.540635v5.023104l39.443784 11.967813v-5.023104z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m187.948508 130.305127v5.023104l39.443784 11.967813v-5.023105z"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m249.727589 163.354801c-3.740156-1.143558-6.768207-5.091504-6.768207-8.829976s3.028051-5.839626 6.768207-4.696068 6.766069 5.091504 6.766069 8.829976-3.025913 5.839626-6.766069 4.696068"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m536.381788 357.2727-122.09717 37.044859-.002138-12.769372 122.099308-37.044859z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m292.187663 357.2727 122.095031 37.044859.002138-12.792885-122.097169-37.044859z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m122.405034.70964706 122.099308 37.04272144-122.09717 37.044859-122.09716968-37.044859z"
            fill="#03313f"
            mask="url(#b)"
            transform="translate(291.878088 306.750532)"
            data-v-3089ed99=""
          ></path>
          <g fill="#77d9e2" data-v-3089ed99="">
            <path
              d="m417.41446 332.995289 22.678304-6.880584-22.678304-6.880584-22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m388.575697 341.743399 22.678304-6.880584-22.678304-6.880584-22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m359.721109 350.492791 22.678305-6.880583-22.678305-6.880584-22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m447.532446 342.642 22.678304-6.880584-22.678304-6.880584-22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m418.693683 351.391393 22.678304-6.880584-22.678304-6.880584-22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m389.840164 360.139717 22.678305-6.880584-22.678305-6.880584-22.678304 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m440.399846 365.595021 36.943932-11.209003-22.678305-6.878447-36.943931 11.206866z"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m414.283121 307.466377v-135.439988l-122.099308 37.070509.004277 135.414338z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m407.238199 301.942031v-120.233876l-108.009035 32.910951.002138 120.208227z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m399.804719 295.931406v-103.683282l-93.142503 28.379469.002139 103.661908z"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m414.283121 172.025747-11.793573-3.57816-121.780679 37.136771 11.474944 3.514036z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m292.184455 209.097966-11.477083-3.514035v148.205086l11.479221 3.48411z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m.00042769 357.2727 122.09503131 37.044859.002138-12.769372-122.09716931-37.044859z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m244.194553 357.2727-122.097169 37.044859-.002139-12.792885 122.099308-37.044859z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m122.098025 307.460179-122.09716962 37.042721 122.09503162 37.044859 122.099308-37.044859z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <g fill="#03313f" data-v-3089ed99="">
            <path
              d="m118.967756 332.995289-22.6783046-6.880584 22.6783046-6.880584 22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m147.806519 341.743399-22.678305-6.880584 22.678305-6.880584 22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m176.660037 350.492791-22.678304-6.880583 22.678304-6.880584 22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m88.8487007 342.642-22.6783047-6.880584 22.6783047-6.880584 22.6783043 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m117.687464 351.391393-22.678305-6.880584 22.678305-6.880584 22.678304 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m146.542051 360.139717-22.678304-6.880584 22.678304-6.880584 22.678305 6.880584z"
              data-v-3089ed99=""
            ></path>
            <path
              d="m95.9813002 365.595021-36.9439314-11.209003 22.6783047-6.878447 36.9439315 11.206866z"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m122.098025 307.466377v-135.439988l122.099308 37.070509-.002138 135.414338z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m129.143162 301.942031v-120.233876l108.009034 32.910951-.002138 120.208227z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m136.576428 295.931406v-103.683282l93.142502 28.379469-.002138 103.661908z"
            fill="#fff"
            data-v-3089ed99=""
          ></path>
          <path
            d="m122.098025 172.025747 11.793574-3.57816 121.782817 37.136771-11.477083 3.514036z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m244.197761 209.097966 11.477083-3.514035v148.205086l-11.479222 3.48411z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m167.92766 232.521663c13.063816 3.992833 23.691932 17.860876 23.691932 30.918809 0 13.057934-10.628116 20.432278-23.691932 16.441582-13.063815-3.992833-23.689793-17.863013-23.689793-30.920947 0-13.055796 10.625978-20.432278 23.689793-16.439444"
            fill="#f53251"
            class="left-venn"
            data-v-3089ed99=""
          ></path>
          <path
            d="m198.368125 241.758403c13.063816 3.992834 23.689794 17.860876 23.689794 30.91881 0 13.057933-10.625978 20.432278-23.689794 16.439444-13.063815-3.990696-23.689793-17.860876-23.689793-30.918809 0-13.055796 10.625978-20.432278 23.689793-16.439445"
            fill="#77d9e2"
            class="right-venn"
            data-v-3089ed99=""
          ></path>
          <path
            d="m174.678118 258.198703c0 7.28457 3.312465 14.819226 8.50677 20.752901 5.149397-2.772326 8.434063-8.261403 8.434063-15.509635 0-7.286708-3.312465-14.819227-8.50677-20.755039-5.151536 2.774463-8.434063 8.261403-8.434063 15.511773"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m174.678118 258.198703c0 7.28457 3.312465 14.819226 8.50677 20.752901 5.149397-2.772326 8.434063-8.261403 8.434063-15.509635 0-7.286708-3.312465-14.819227-8.50677-20.755039-5.151536 2.774463-8.434063 8.261403-8.434063 15.511773"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <g fill="#77d9e2" class="left-cpu progress" data-v-3089ed99="">
            <path
              d="m197.160113 217.25335v3.973596l8.254432 2.524377v-3.975733z"
              class="first"
              data-v-3089ed99=""
            ></path>
            <path
              d="m185.529061 213.698488v3.973596l8.339971 2.550027v-3.975733z"
              class="second"
              data-v-3089ed99=""
            ></path>
            <path
              d="m208.713752 220.784272v3.973596l6.541531 1.998554v-3.973596z"
              class="third"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m222.710789 225.061391-5.027505-1.536856v3.975734l5.027505 1.534718z"
            fill="#f53251"
            class="left-cpu-last fourth"
            data-v-3089ed99=""
          ></path>
          <path
            d="m235.712803 187.109381c-.188184 0-.376368-.027787-.560275-.083362l-86.04925-26.244116h-11.231161v11.144879c0 1.062333-.859658 1.919467-1.920332 1.919467-1.060673 0-1.920331-.857134-1.920331-1.919467v-13.064346c0-1.060196.859658-1.919467 1.920331-1.919467h13.438045c.190323 0 .378507.027787.560275.083362l83.842366 25.570806v-20.137304c0-.773771.464045-1.472731 1.178289-1.769842l14.015427-5.867414c.979412-.41681 2.1021.049163 2.512684 1.028134.410583.976833-.051323 2.101153-1.028597 2.511552l-12.837139 5.373653v21.453998c0 .609185-.288692 1.179895-.778397 1.543269-.333599.245811-.735629.376198-1.141935.376198"
            fill="#03313f"
            class="wire upper-left"
            data-v-3089ed99=""
          ></path>
          <path
            d="m301.604986 187.109381c-.406306 0-.808335-.130387-1.141934-.376198-.489706-.363374-.778397-.934084-.778397-1.543269v-21.453998l-12.83714-5.373653c-.977273-.410399-1.439179-1.534719-1.028596-2.511552.408445-.976834 1.531133-1.442807 2.512683-1.028134l14.015428 5.867414c.714243.297111 1.178288.996071 1.178288 1.769842v20.137304l83.842366-25.570806c.181769-.055575.369953-.083362.560275-.083362h13.438045c1.060673 0 1.920332.859271 1.920332 1.919467v13.064346c0 1.062333-.859659 1.919467-1.920332 1.919467s-1.920332-.857134-1.920332-1.919467v-11.144879h-11.23116l-86.049251 26.244116c-.183907.055575-.372091.083362-.560275.083362"
            fill="#03313f"
            class="wire upper-right"
            data-v-3089ed99=""
          ></path>
          <path
            d="m267.923266 435-41.045486-12.542798v-41.029142l41.045486 12.544935z"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <path
            d="m267.923266 435 41.045487-12.542798v-41.029142l-41.045487 12.544935z"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m267.923266 368.885903-41.045486 12.542798 41.045486 12.542798 41.045487-12.542798z"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m246.013522 398.31595c6.417501 1.960079 11.639605 8.774401 11.639605 15.189012s-5.222104 10.037658-11.639605 8.077579c-6.4175-1.962217-11.637467-8.774402-11.637467-15.19115 0-6.414611 5.219967-10.037658 11.637467-8.075441"
            fill="#77d9e2"
            data-v-3089ed99=""
          ></path>
          <path
            d="m246.013522 405.248261c2.593945.793009 4.702461 3.546098 4.702461 6.138874 0 2.59064-2.108516 4.054821-4.702461 3.261812-2.591806-.790872-4.70246-3.54396-4.70246-6.136737s2.110654-4.056958 4.70246-3.263949"
            fill="#03313f"
            data-v-3089ed99=""
          ></path>
          <path
            d="m214.336603 425.897921c-.243784 0-.487567-.044887-.718521-.138936l-52.274508-21.090626c-.739905-.299248-1.221057-1.025995-1.201811-1.825417.019246-.797284.530337-1.502656 1.285211-1.765568l39.788075-13.930029-30.425923-12.948922c-.975135-.414673-1.428488-1.543268-1.013627-2.517964.41486-.974696 1.537548-1.427844 2.519098-1.013171l34.985108 14.887626c.729213.309936 1.191119 1.036683 1.165457 1.829692-.025661.793009-.534613 1.487694-1.283072 1.748468l-39.653353 13.883005 46.787235 18.876184 31.093122-13.985604c.966581-.436049 2.1021-.004275 2.538345.961871.436244.968283.004276 2.103291-.962305 2.539339l-31.839441 14.321191c-.252338.113287-.519645.168861-.78909.168861"
            fill="#03313f"
            class="wire lower-left"
            data-v-3089ed99=""
          ></path>
          <path
            d="m288.348282 398.31595c-6.4175 1.960079-11.637466 8.774401-11.637466 15.189012s5.219966 10.037658 11.637466 8.077579c6.417501-1.962217 11.639605-8.774402 11.639605-15.19115 0-6.414611-5.222104-10.037658-11.639605-8.075441"
            fill="#f53251"
            data-v-3089ed99=""
          ></path>
          <g fill="#03313f" data-v-3089ed99="">
            <path
              d="m288.348282 405.248261c-2.593945.793009-4.70246 3.546098-4.70246 6.138874 0 2.59064 2.108515 4.054821 4.70246 3.261812 2.593945-.790872 4.702461-3.54396 4.702461-6.136737s-2.108516-4.056958-4.702461-3.263949"
              data-v-3089ed99=""
            ></path>
            <path
              d="m282.709821 382.906776c-1.967378 0-3.562665-1.594568-3.562665-3.56106v-6.410336c0-6.038413-4.914167-10.952505-10.957438-10.952505-6.041133 0-10.9553 4.914092-10.9553 10.952505v6.410336c0 1.966492-1.595287 3.56106-3.562664 3.56106-1.967378 0-3.560526-1.594568-3.560526-3.56106v-6.410336c0-9.964984 8.111156-18.072488 18.07849-18.072488 9.971611 0 18.082767 8.107504 18.082767 18.072488v6.410336c0 1.966492-1.595287 3.56106-3.562664 3.56106"
              data-v-3089ed99=""
            ></path>
            <path
              d="m320.292508 425.897921c-.269445 0-.536752-.055574-.789089-.168861l-31.839442-14.321191c-.966581-.436048-1.398549-1.571056-.962304-2.539339.434106-.964009 1.571763-1.391507 2.538345-.961871l31.093121 13.985604 46.785096-18.876184-39.651214-13.883005c-.748459-.260774-1.257411-.955459-1.283072-1.748468-.025662-.793009.436244-1.519756 1.165457-1.829692l34.985108-14.887626c.977273-.414673 2.104238.038475 2.519099 1.013171.41486.974696-.038493 2.103291-1.013628 2.517964l-30.425923 12.948922 39.785937 13.930029c.754874.262912 1.265964.968284 1.28521 1.765568.019246.799422-.459767 1.526169-1.201811 1.825417l-52.272369 21.090626c-.230953.094049-.474737.138936-.718521.138936"
              class="wire lower-right"
              data-v-3089ed99=""
            ></path>
            <path
              d="m259.491556 383.399468v-.010688c0-.316349-.002138-.643385-.002138-.976833l-.012831-4.031309c-.002138-.521547-.004277-1.045233-.006415-1.568918v-.465973c-.006416-1.395782-.010693-2.765914-.01497-4.031308l-.002138-.974696c0-.230849-.177492-.463836-.551721-.686135-.076984-.044887-.162523-.089775-.252338-.130387-.025661-.012825-.051323-.02565-.079122-.038475-.070569-.029925-.143277-.05985-.220261-.089774-.0278-.010688-.0556-.021375-.085538-.0342-.100508-.036338-.205292-.072675-.31863-.106875-.002138 0-.004277 0-.006415 0-.134723-.040612-.273723-.079087-.419137-.117562-.004277 0-.006416 0-.008554-.002137-.119754-.027788-.243784-.055575-.369953-.083363-.010692-.002137-.019246-.002137-.0278-.004275-.029938-.006412-.062015-.010687-.091953-.017099-.074846-.014963-.149692-.032063-.226676-.044888-.036354-.006412-.074846-.010687-.1112-.0171-.038492-.006412-.076984-.012825-.115476-.019237-.034216-.006413-.066292-.010688-.102646-.0171-.104784-.0171-.213846-.029925-.320768-.044887-.002139 0-.006416-.002138-.008554-.002138-.004277 0-.008554 0-.014969-.002137-.098369-.012825-.196738-.023513-.299384-.0342-.047046-.006413-.098369-.010688-.147553-.014963-.032077-.004275-.062015-.006412-.096231-.010687-.025661-.002138-.051323-.004275-.076984-.006413-.109061-.010687-.215984-.019237-.325045-.027787-.019246-.002137-.038492-.002137-.057738-.004275-.0278-.002137-.057738-.004275-.085538-.004275-.062016-.004275-.126169-.00855-.188184-.012825-.085538-.004275-.173215-.00855-.258753-.012825-.021385 0-.040631-.002137-.057739-.002137-.010692 0-.019246 0-.025661-.002138-.119753-.004275-.237368-.006412-.357122-.010687-.036354 0-.070569 0-.104784 0-.040631-.002138-.081261-.002138-.121892-.002138-.051323 0-.100507-.002137-.15183-.002137-.087677 0-.177492.002137-.265168.002137h-.104785c-.010692.002138-.025661 0-.038492.002138-.15183.002137-.305799.006412-.459767.012825-.006416 0-.012831 0-.021385 0-.091954.004275-.186046.010687-.280137.0171-.087677.004275-.175354.006412-.265169.012825-.004277 0-.008554 0-.012831.002137-.267306.0171-.532475.04275-.793366.074812-.029938.002138-.062015.004275-.091953.006413-.0834.010687-.164661.021375-.248061.032062-.139.019237-.275861.040612-.408445.05985-.044907.00855-.085538.0171-.130446.023512-.085538.014963-.173214.029925-.254476.047025-.014969.002138-.029938.004275-.042769.006413-.036353.006412-.070569.014962-.106922.023512-.068431.014962-.139.027787-.205292.04275-.049184.012825-.09623.023512-.145415.0342-.064153.0171-.126169.032062-.188184.047024-.019246.006413-.042769.010688-.064153.0171-.019246.004275-.036354.010688-.0556.0171-.094092.02565-.183907.0513-.271584.081225-.019246.006412-.038492.010687-.057738.0171-.008554.002137-.012831.004275-.021385.006412-.076984.02565-.149691.053438-.22026.079087-.01497.006413-.032077.010688-.047046.0171 0 0-.002139 0-.004277.002138-.049185.019237-.096231.038475-.141138.05985-.0278.010687-.057739.021375-.085538.0342 0 0 0 0-.002139.002137-.017108.006412-.029938.014962-.047046.021375-.047046.023512-.09623.044887-.141138.070537-.004277 0-.006415.002138-.008554.004275-.017107.00855-.034215.0171-.049184.027787-.036354.019238-.070569.038475-.102646.057713-.006415.004275-.010692.00855-.017108.010687-.017107.010688-.034215.023513-.053461.0342-.021384.014963-.044907.029925-.064153.044887-.010693.006413-.017108.012825-.0278.019238l-.047046.038475c-.012831.010687-.0278.021375-.040631.032062-.010692.010687-.021385.021375-.032077.032062-.014969.012825-.0278.02565-.04063.038475-.006416.006413-.01497.014963-.021385.021375-.014969.014963-.025661.029925-.038492.047025-.008554.010687-.019246.023512-.0278.0342-.004277.004275-.008554.00855-.010692.012825-.014969.021375-.0278.044887-.040631.068399-.004277.00855-.010692.0171-.014969.023513 0 .002137 0 .002137-.002139.004275-.014969.0342-.027799.0684-.038492.100462v.004275c-.002138.010687-.002138.021375-.004277.032062-.004277.023513-.008553.047025-.008553.072675 0 .004275-.002139.00855-.002139.010687l.038492 12.049038c.002139.230849.17963.463836.551721.686135.076985.044887.162523.087637.252338.130387.025661.012825.053461.02565.079123.036337.070569.032062.143276.061987.220261.091912.027799.010688.055599.021375.085538.032062.102645.036338.20743.072675.318629.109012h.006416c.134722.040613.27586.079088.421275.115425.002139.002138.004277.002138.008554.002138.119753.029924.241645.057712.367814.083362.010692.002137.021385.004275.029938.006412.029939.006413.062016.010688.091954.0171.074846.014963.147553.029925.224538.04275.036353.006412.074845.012825.113338.019237.038492.006413.074846.012825.113338.019238.034215.006412.06843.010687.102645.0171.104785.014962.213846.029925.322907.044887h.006415c.004277 0 .010693.002137.01497.002137.098368.012825.198876.02565.299383.036338.049185.004275.098369.00855.149692.014962.029938.002138.062015.006413.091953.00855.0278.004275.053462.006413.079123.00855.109061.00855.215984.019238.327184.02565.017107.002138.036353.004275.0556.004275.029938.002138.057738.004275.087676.006413.062015.004275.12403.008549.186046.012824.087676.004275.175353.006413.260891.010688.019246.002137.038492.002137.057738.002137.008554.002138.017108.002138.025662.002138.117615.004275.237368.00855.357122.010687.034215.002138.06843 0 .100507.002138h.126169c.049184.002137.098369.002137.149691.002137.087677 0 .177492 0 .267307-.002137h.102646.038492c.153969-.002138.307938-.006413.461906-.012825.006416 0 .012831-.002138.019246-.002138.094092-.004275.186046-.010687.280138-.014962.087676-.004275.177491-.00855.265168-.012825.004277-.002137.008554-.002137.014969-.002137.265169-.019238.530337-.044888.791228-.074813.029939-.002137.062015-.004275.091954-.00855.083399-.00855.164661-.019237.24806-.032062.141138-.0171.275861-.038475.410584-.05985.042769-.006412.083399-.014962.12403-.021375.089815-.014962.175353-.029925.260891-.047024.012831-.004275.0278-.004275.042769-.006413.036354-.00855.068431-.0171.104785-.023512.070569-.014963.138999-.029925.20743-.044888.049184-.010687.09623-.021375.143276-.034199.064154-.014963.126169-.029925.188184-.047025.021385-.004275.042769-.010688.064154-.014963.019246-.006412.036353-.010687.055599-.0171.094092-.027787.186046-.053437.271584-.081224.019246-.006413.040631-.010688.057738-.0171.008554-.002138.01497-.006413.021385-.00855.076984-.023513.149692-.0513.222399-.07695.012831-.006412.029938-.012825.044908-.0171.002138-.002137.002138-.002137.004277-.002137.051322-.019238.09623-.040613.143276-.05985.0278-.010688.057738-.023512.0834-.036337h.002138c.017108-.006413.032077-.014963.047046-.021375.049185-.023513.098369-.047025.141138-.070538.004277-.002137.006415-.004275.008554-.004275.017108-.008549.034215-.019237.051323-.027787.034215-.019237.06843-.038475.100507-.057712.006416-.004275.010692-.00855.017108-.010688.019246-.012825.034215-.023512.053461-.036337.021385-.012825.044908-.027787.066292-.044887.008554-.004275.014969-.010688.025662-.019238.014969-.012825.032076-.02565.047046-.036337.01283-.012825.0278-.023512.04063-.0342.012831-.00855.021385-.019237.032077-.029925.014969-.014962.0278-.02565.040631-.038475.006415-.00855.017107-.014962.023523-.021375.01283-.017099.023523-.032062.036353-.047024.010693-.010688.019247-.023513.029939-.036338.002138-.004275.006415-.006412.008554-.010687.017107-.023513.027799-.044887.04063-.0684.004277-.00855.010692-.0171.014969-.02565.002139 0 .002139-.002137.002139-.002137.017107-.0342.029938-.0684.038492-.1026v-.002137c.002138-.010688.002138-.021375.004277-.032063.004277-.02565.010692-.049162.010692-.072674"
              data-v-3089ed99=""
            ></path>
            <path
              d="m288.528768 383.399468v-.010688c0-.316349-.002139-.643385-.002139-.976833l-.01283-4.031309c-.002139-.521547-.004277-1.045233-.006416-1.568918v-.465973c-.006415-1.395782-.010692-2.765914-.014969-4.031308l-.002138-.974696c0-.230849-.177492-.463836-.551722-.686135-.076984-.044887-.162522-.089775-.252337-.130387-.025662-.012825-.051323-.02565-.079123-.038475-.070569-.029925-.143276-.05985-.220261-.089774-.0278-.010688-.0556-.021375-.085538-.0342-.100507-.036338-.205291-.072675-.31863-.106875-.002138 0-.004276 0-.006415 0-.132584-.040612-.273722-.079087-.419137-.117562-.004277 0-.006415 0-.008554-.002137-.119753-.027788-.243783-.055575-.369952-.083363-.010693-.002137-.019246-.002137-.0278-.004275-.029938-.006412-.062015-.010687-.091954-.017099-.074846-.014963-.149691-.032063-.226676-.044888-.036354-.006412-.074846-.010687-.111199-.0171-.038493-.006412-.076985-.012825-.115477-.019237-.034215-.006413-.066292-.010688-.102646-.0171-.104784-.0171-.213845-.029925-.320768-.044887-.002138 0-.004277-.002138-.006415-.002138-.006416 0-.010692 0-.017108-.002137-.098369-.012825-.196738-.023513-.297245-.0342-.049184-.006413-.100507-.010688-.149692-.014963-.032076-.004275-.062015-.006412-.09623-.010687-.025662-.002138-.051323-.004275-.076984-.006413-.109062-.010687-.215984-.019237-.325045-.027787-.019247-.002137-.038493-.002137-.057739-.004275-.0278-.002137-.057738-.004275-.085538-.004275-.062015-.004275-.126169-.00855-.188184-.012825-.085538-.004275-.173215-.00855-.258753-.012825-.021384 0-.04063-.002137-.057738-.002137-.010692 0-.019246 0-.025661-.002138-.119754-.004275-.237369-.006412-.357122-.010687-.036354 0-.070569 0-.104785 0-.04063-.002138-.081261-.002138-.121891-.002138-.051323 0-.100508-.002137-.151831-.002137-.087676 0-.177491.002137-.265168.002137h-.104784c-.010692.002138-.025662 0-.038492.002138-.151831.002137-.305799.006412-.459768.012825-.006415 0-.012831 0-.021385 0-.091953.004275-.186045.010687-.280137.0171-.087677.004275-.175353.006412-.265168.012825-.004277 0-.008554 0-.012831.002137-.267307.0171-.530337.04275-.793366.074812-.029939.002138-.062016.004275-.091954.006413-.0834.010687-.164661.021375-.245922.032062-.141138.019237-.277999.040612-.410583.05985-.044908.00855-.085539.0171-.128308.023512-.087676.014963-.173214.029925-.256614.047025-.014969.002138-.029938.004275-.042769.006413-.036354.006412-.070569.014962-.106923.023512-.06843.014962-.138999.027787-.205291.04275-.049185.012825-.096231.023512-.145415.0342-.064154.0171-.126169.032062-.188184.047024-.019246.006413-.042769.010688-.064154.0171-.019246.004275-.036354.010688-.0556.0171-.094092.02565-.183907.0513-.271583.081225-.019246.006412-.038493.010687-.057739.0171-.008553.002137-.01283.004275-.021384.006412-.076984.02565-.149692.053438-.220261.079087-.014969.006413-.032077.010688-.047046.0171 0 0-.002138 0-.004277.002138-.049184.019237-.09623.038475-.141138.05985-.0278.010687-.057738.021375-.085538.0342 0 0 0 0-.002138.002137-.017108.006412-.029939.014962-.047046.021375-.047046.023512-.096231.044887-.141138.070537-.004277 0-.006416.002138-.008554.004275-.017108.00855-.034215.0171-.049185.027787-.036353.019238-.070569.038475-.102645.057713-.006416.004275-.010693.00855-.017108.010687-.017108.010688-.034215.023513-.053461.0342-.021385.014963-.044908.029925-.064154.044887-.010692.006413-.017108.012825-.025661.019238-.017108.012825-.032077.02565-.049185.038475-.012831.010687-.0278.021375-.04063.032062-.010693.010687-.021385.021375-.032077.032062-.014969.012825-.0278.02565-.040631.038475-.006415.006413-.014969.014963-.021384.021375-.01497.014963-.025662.029925-.038493.047025-.008553.010687-.019246.023512-.0278.0342-.004276.004275-.008553.00855-.010692.012825-.014969.021375-.0278.044887-.04063.068399-.004277.00855-.010693.0171-.01497.023513 0 .002137 0 .002137-.002138.004275-.014969.0342-.0278.0684-.038492.100462v.004275c-.002139.010687-.002139.021375-.004277.032062-.004277.023513-.008554.047025-.008554.072675v.010687l.036354 12.049038c.002138.230849.17963.463836.551721.686135.076984.044887.162522.087637.252337.130387.025662.012825.053462.02565.081262.036337.06843.032062.141138.061987.218122.091912.0278.010688.0556.021375.085538.032062.102646.036338.20743.072675.31863.109012h.006415c.134723.040613.275861.079088.421276.115425.002138.002138.004277.002138.008553.002138.119754.029924.241646.057712.369953.083362.008554.002137.019246.004275.0278.006412.029938.006413.062015.010688.091953.0171.074846.014963.147554.029925.224538.04275.036354.006412.076984.012825.113338.019237.038492.006413.074846.012825.113338.019238.034215.006412.068431.010687.102646.0171.104784.014962.213845.029925.322907.044887h.006415c.004277 0 .010692.002137.014969.002137.098369.012825.198876.02565.299384.036338.049184.004275.100507.00855.149691.014962.029939.002138.062016.006413.091954.00855.0278.004275.053461.006413.079123.00855.109061.00855.215984.019238.327183.02565.017108.002138.036354.004275.0556.004275.029938.002138.057738.004275.087677.006413.062015.004275.12403.008549.186045.012824.087677.004275.175353.006413.260892.010688.019246.002137.038492.002137.057738.002137.008554.002138.017107.002138.025661.002138.117615.004275.237369.00855.357122.010687.034215.002138.068431 0 .102646.002138h.12403c.049185.002137.100508.002137.149692.002137.087677 0 .177492 0 .267307-.002137h.102645.038493c.153968-.002138.307937-.006413.461906-.012825.006415 0 .01283-.002138.019246-.002138.094092-.004275.186045-.010687.280137-.014962.087677-.004275.177492-.00855.265169-.012825.004276-.002137.008553-.002137.014969-.002137.265168-.019238.530336-.044888.791228-.074813.029938-.002137.062015-.004275.091953-.00855.0834-.00855.1668-.019237.248061-.032062.141138-.0171.27586-.038475.410583-.05985.042769-.006412.0834-.014962.12403-.021375.089815-.014962.175354-.029925.260892-.047024.012831-.004275.0278-.004275.042769-.006413.036354-.00855.06843-.0171.104784-.023512.070569-.014963.139-.029925.20743-.044888.049185-.010687.096231-.021375.143277-.034199.064153-.014963.126168-.029925.188184-.047025.021384-.004275.042769-.010688.064153-.014963.019246-.006412.036354-.010687.0556-.0171.094092-.027787.186045-.053437.271584-.081224.019246-.006413.04063-.010688.057738-.0171.008554-.002138.014969-.006413.021384-.00855.076985-.023513.149692-.0513.2224-.07695.01283-.006412.029938-.012825.044907-.0171.002139-.002137.002139-.002137.004277-.002137.051323-.019238.096231-.040613.143277-.05985.027799-.010688.057738-.023512.083399-.036337h.002139c.017107-.006413.032076-.014963.047046-.021375.049184-.023513.098369-.047025.143276-.070538.002139-.002137.004277-.004275.006415-.004275.017108-.008549.034216-.019237.051323-.027787.034216-.019237.068431-.038475.100508-.057712.006415-.004275.010692-.00855.017107-.010688.019246-.012825.034216-.023512.053462-.036337.021384-.012825.044907-.027787.066292-.044887.008554-.004275.017107-.010688.025661-.019238.014969-.012825.032077-.02565.047046-.036337.012831-.012825.0278-.023512.040631-.0342.012831-.00855.021384-.019237.032077-.029925.014969-.014962.027799-.02565.04063-.038475.006416-.00855.017108-.014962.023523-.021375.012831-.017099.023523-.032062.036354-.047024.010692-.010688.019246-.023513.029938-.036338l.008554-.010687c.017108-.023513.0278-.044887.040631-.0684.004277-.00855.010692-.0171.014969-.02565.002138 0 .002138-.002137.002138-.002137.017108-.0342.029939-.0684.038493-.1026v-.002137c.002138-.010688.002138-.021375.004276-.032063.004277-.02565.010693-.049162.010693-.072674"
              data-v-3089ed99=""
            ></path>
          </g>
          <g fill="#03313f" data-v-3089ed99="">
            <path
              d="m369.078984 233.491229c-12.666063 3.870996-22.971273 17.307266-22.971273 29.950526 0 5.786188 2.187638 10.591268 6.163024 13.530319 4.249108 3.144249 10.012242 3.832521 16.215897 1.940842 12.666063-3.873134 22.971273-17.307266 22.971273-29.950526 0-5.786189-2.187638-10.591269-6.160886-13.530319-4.253385-3.146387-10.012242-3.836797-16.218035-1.940842m-7.253636 48.499674c-4.037401 0-7.724096-1.14142-10.762839-3.387924-4.503584-3.332348-6.984191-8.716688-6.984191-15.161224 0-13.472607 10.948885-27.776698 24.408314-31.889231 6.834499-2.090466 13.232753-1.291044 18.016475 2.248641 4.503584 3.330211 6.986329 8.714552 6.986329 15.161225 0 13.470469-10.951023 27.776697-24.410452 31.88923-2.495576.763084-4.933414 1.139283-7.253636 1.139283"
              data-v-3089ed99=""
            ></path>
            <path
              d="m345.291891 241.679102c-2.121347 0-4.356031.348412-6.652731 1.049509-12.666063 3.870996-22.973411 17.305128-22.973411 29.948388 0 5.786189 2.189777 10.591269 6.163024 13.530319 4.251247 3.146387 10.010104 3.834659 16.218036 1.940842 12.666063-3.870997 22.971272-17.305128 22.971272-29.948388 0-5.788327-2.187638-10.593407-6.160886-13.532457-2.679482-1.981454-5.957732-2.988213-9.565304-2.988213m-13.906367 49.549183c-4.039539 0-7.726234-1.143558-10.764977-3.390061-4.503584-3.330212-6.984191-8.714552-6.984191-15.161225 0-13.470469 10.951023-27.776697 24.410453-31.88923 6.834499-2.090467 13.232753-1.288907 18.016475 2.24864 4.503584 3.332349 6.98419 8.716689 6.98419 15.163363 0 13.470469-10.948884 27.776697-24.408314 31.887092-2.493437.763085-4.931275 1.141421-7.253636 1.141421"
              data-v-3089ed99=""
            ></path>
            <path
              d="m362.032992 258.198703c0 7.28457-3.312466 14.819226-8.50677 20.752901-5.149398-2.772326-8.434063-8.261403-8.434063-15.509635 0-7.286708 3.312465-14.819227 8.50677-20.755039 5.149397 2.774463 8.434063 8.261403 8.434063 15.511773"
              data-v-3089ed99=""
            ></path>
          </g>
          <path
            d="m381.439889 204.983723v3.973596l-8.254432 2.524377v-3.975733z"
            fill="#77d9e2"
            class="right-cpu third"
            data-v-3089ed99=""
          ></path>
          <path
            d="m393.070941 201.429931v3.973596l-8.339971 2.547889v-3.973596z"
            fill="#f53251"
            class="right-cpu last"
            data-v-3089ed99=""
          ></path>
          <g fill="#77d9e2" data-v-3089ed99="">
            <path
              d="m369.88625 208.514431v3.973596l-6.541531 1.998554v-3.971458z"
              class="right-cpu second"
              data-v-3089ed99=""
            ></path>
            <path
              d="m355.888144 212.79262 5.029644-1.536856v3.973596l-5.029644 1.536856z"
              class="right-cpu first"
              data-v-3089ed99=""
            ></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<style scoped>
.theloader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(3, 49, 63);
  z-index: 999;
}
.theloader {
  top: 50%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, -50%);
}
.wire.lower-left {
  animation: wires 3s ease 0s infinite forwards;
}
.wire.lower-right {
  animation: wires 3s ease 0.75s infinite forwards;
}
.wire.upper-right {
  animation: wires 3s ease 1.5s infinite forwards;
}
.wire.upper-left {
  animation: wires 3s ease 2.25s infinite forwards;
}
@keyframes wires {
  0% {
    fill: rgb(3, 49, 63);
  }
  50% {
    fill: rgb(251, 255, 2);
  }
  100% {
    fill: rgb(3, 49, 63);
  }
}

.left-cpu.progress,
.left-cpu-last,
.right-cpu {
  fill: rgb(119, 217, 226);
}
.left-cpu .first,
.right-cpu.first {
  animation: progress 2s ease 0s infinite forwards;
}
.left-cpu .second,
.right-cpu.second {
  animation: progress 2s ease 0.25s infinite forwards;
}
.left-cpu .third,
.right-cpu.third {
  animation: progress 2s ease 0.5s infinite forwards;
}
.fourth,
.right-cpu.last {
  animation: progress 2s ease 0.75s infinite forwards;
}
@keyframes progress {
  0% {
    fill: rgb(119, 217, 226);
  }
  50% {
    fill: rgb(245, 50, 81);
  }
  100% {
    fill: rgb(119, 217, 226);
  }
}

.left-venn {
  fill: rgb(245, 50, 81);
  animation: progress 2s ease 0.75s infinite forwards;
}

.theloader-wrapper {
  animation: fadeout 0.25s ease 2.75s 1 forwards;
}
@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@media screen and (max-width: 768px) {
  .theloader-wrapper svg {
    max-width: 380px;
  }
}
</style>
